import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as RectangleSelectIcon } from '../../../images/select-rectangle-svgrepo-com.svg';
import { ReactComponent as LassoSelectIcon } from '../../../images/lasso-svgrepo-com.svg';
import { ReactComponent as TableViewIcon } from '../../../images/table-view-icon.svg';
import './DiscoverSelectionActionsToolbar.scss';

export default function DiscoverSelectionActionsToolbar({
    t,
    selectionMode,
    isTableOpen = false,
    onSelectRectangle,
    onSelectLasso,
    onOpenTable,
}) {
    const actions = [
        {
            key: 'rectangle',
            label: t('discoverPage.selection.rectangle', 'Rectangle select'),
            isActive: selectionMode === 'rectangle',
            onClick: onSelectRectangle,
            Icon: RectangleSelectIcon,
        },
        {
            key: 'lasso',
            label: t('discoverPage.selection.lasso', 'Lasso select'),
            isActive: selectionMode === 'lasso',
            onClick: onSelectLasso,
            Icon: LassoSelectIcon,
        },
        {
            key: 'table',
            label: t('discoverPage.table.viewButton', 'View in table'),
            isActive: isTableOpen,
            onClick: onOpenTable,
            Icon: TableViewIcon,
        },
    ];

    return (
        <aside
            className="discover-selection-actions-toolbar"
            aria-label={t('discoverPage.selection.actionsAria', 'Selection actions')}
        >
            {actions.map((action) => (
                <button
                    key={action.key}
                    type="button"
                    className={`discover-selection-actions-toolbar__button${action.isActive ? ' is-active' : ''}`}
                    onClick={action.onClick}
                    aria-pressed={action.isActive}
                    aria-label={action.label}
                    title={action.label}
                >
                    <action.Icon
                        className={`discover-selection-actions-toolbar__icon${
                            action.key === 'table' ? ' discover-selection-actions-toolbar__icon--table' : ''
                        }`}
                        aria-hidden="true"
                        focusable="false"
                    />
                </button>
            ))}
        </aside>
    );
}

DiscoverSelectionActionsToolbar.propTypes = {
    t: PropTypes.func.isRequired,
    selectionMode: PropTypes.string.isRequired,
    isTableOpen: PropTypes.bool,
    onSelectRectangle: PropTypes.func.isRequired,
    onSelectLasso: PropTypes.func.isRequired,
    onOpenTable: PropTypes.func.isRequired,
};
